import { datadogRum } from '@datadog/browser-rum';

const applicationId =
  process.env.REACT_APP_DATADOG_APPLICATION_ID || '0bfacf3f-9a6f-429b-990a-7a25515855a0';
const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN || 'pubc263d4314dab1914a08a20a39d3a3922';

if (applicationId && clientToken) {
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    service: 'plataforma',
    env: 'prod',
    version: '1',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true
    // allowedTracingUrls: '<BACKEND_URL>',
    // defaultPrivacyLevel: 'mask-user-input',
  });
}
